module.exports = __webpack_public_path__ + "static/media/whatsapp.10534e0a.svg";